import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Divider, Text, VStack } from '@adc/parallax-component-library';
import { Button, Link } from 'Components/utility';
import { checkBrowser } from 'Utilities/browser';
import { store } from 'Utilities/store';
const { isAndroid } = checkBrowser();
const mapStateToProps = ({ scrollPage }) => {
    return {
        scrollPage,
    };
};
const connector = connect(mapStateToProps);
const Footer = ({ scrollPage, buttonText, onButtonSubmit, testIDButton, isButtonDisabled, linkText, onButtonLinkClick, testIDButtonLink, buttonLinkText, customProps, visible = true, }) => {
    const footerRef = useRef();
    const [isVisible, setIsVisible] = useState(visible);
    useEffect(() => {
        if (footerRef.current) {
            store.dispatch({ type: 'FOOTER_SIZE', footerSize: footerRef.current.clientHeight });
            // This is a hack to prevent the footer from moving to the top of screen when the keyboard is open on Android.
            if (isAndroid) {
                const sumedges = window.innerWidth + window.innerHeight;
                window.visualViewport?.addEventListener('resize', () => {
                    const keyboardDidShow = window.innerWidth + window.innerHeight < sumedges;
                    setIsVisible(!keyboardDidShow);
                });
            }
        }
    }, []);
    const hasScrollOrBottomedOut = !scrollPage.isActive || scrollPage.bottomedOut;
    const onButtonClick = useCallback(() => {
        onButtonSubmit && onButtonSubmit();
        store.dispatch({ type: 'SCROLL_RESET' });
    }, [onButtonSubmit]);
    const onButtonLink = useCallback(() => {
        onButtonLinkClick && onButtonLinkClick();
        store.dispatch({ type: 'SCROLL_RESET' });
    }, [onButtonLinkClick]);
    if (!isVisible) {
        return null;
    }
    return (React.createElement(VStack, { ref: footerRef, padding: 4, paddingBottom: isAndroid ? '$4' : '$8', alignSelf: "flex-end", width: "100%", backgroundColor: !scrollPage.isActive || scrollPage.bottomedOut
            ? '$surface.background'
            : '$surface.scrollContainer', style: {
            shadowOffset: { width: 0, height: hasScrollOrBottomedOut ? 0 : -4 },
            shadowOpacity: hasScrollOrBottomedOut ? 0 : 0.08,
            shadowRadius: hasScrollOrBottomedOut ? 0 : 12,
        } }, customProps ? (customProps) : (React.createElement(React.Fragment, null,
        React.createElement(Button, { marginHorizontal: "$3", onPress: onButtonClick, testID: testIDButton, disabled: isButtonDisabled, "aria-label": buttonText, label: buttonText }),
        onButtonLinkClick && buttonLinkText && testIDButtonLink && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { marginTop: "$5", borderColor: "$neutral.40" }),
            React.createElement(Text, { nativeID: `${testIDButtonLink}-title`, fontFamily: "$body", fontWeight: "$bodySmall.default", color: "$text.100", textAlign: "center", fontSize: "$bodySmall.default", marginVertical: "$2" }, linkText),
            React.createElement(Link, { testID: testIDButtonLink, onPress: onButtonLink }, buttonLinkText)))))));
};
const ConnectedFooter = connector(Footer);
export { ConnectedFooter as Footer };
